module.exports = __webpack_public_path__ + "static/scale-model-of-hawkins-sculpture-walk-in-houston-texas-79cdae31d00923cb866582c88a32afee.png";